// extracted by mini-css-extract-plugin
export default {"form":"Form_form__psS5c","input":"Form_input__EwUhk","button_wrapper":"Form_button_wrapper__xjJDb"};